<template>
  <div>
    <v-progress-circular
      v-if="!show"
      class="primary--text"
      :style="{marginLeft: '2rem'}"
      indeterminate
    ></v-progress-circular>
          <v-row  v-if="show && !pausedNotificationsPeriod" class="main_row"
            align="center"
            justify="space-between"
            >
            <v-col class="mobile_style"
              align="center"
              justify="end"
              >
              <v-row
                class="selectors_row"
                align="center"
                justify="start"
                >
                <div class="div_datepickers">
                    <h4 class="primary--text titleNotif">
                        {{ $t("stopMobileNotif.title") }}
                    </h4>
                  <div class="datepicker">
                    <v-menu
                      ref="menu_inicio"
                      v-model="menu_inicio"
                      :close-on-content-click="false"
                      :return-value.sync="date_inicio"
                      transition="scroll-y-transition"
                      offset-y
                      min-width="auto"
                      >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          readonly
                          v-model="computedDateFormatted"
                          :label="$t('stopMobileNotif.labelDateSuscription') "
                          prepend-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                          :hint="$t('stopMobileNotif.hintDateStart')"
                          persistent-hint
                          :style="{width: '16rem'}"
                          @click="() => {
                            selectedPeriod = '';
                          }"
                        ></v-text-field>
                      </template>
                      <div @click="sendDatesValues">
                        <v-date-picker
                            v-model="selectedDates"
                            no-title
                            range
                            scrollable
                            :first-day-of-week="1"
                            locale="es-es"
                            :allowed-dates="allowedDatesIni"
                            :max="maxDate"
                            color="#27846d"
                        >
                        </v-date-picker>
                    </div>
                    </v-menu>
                  </div>
                </div>

                <p class="error_message" id="app" v-if="errorMessage">
                    {{ errorMessage }}
                </p>
              </v-row>
              <v-row
                align="center"
                justify="start"
                :style="{marginLeft: '0.4rem', gap: '1rem' }"
                >
                <p class="error_message" id="web" v-if="errorMessage">
                  {{ errorMessage }}
                </p>
              </v-row>
            </v-col>
          </v-row>
        <v-row class="period-style"
        v-else-if="show && pausedNotificationsPeriod"
        :style="{alignItems: 'center', gap: '1rem'}"
        >
          <v-col cols="12">
            <v-row
            :style="{alignItems: 'center',
             gap: '1rem'}">
              <h4 class="primary--text"> {{ $t('stopMobileNotif.pausedNotificationsTitle') }}</h4>
              <v-row
              :style="{alignItems: 'center', marginLeft: '0.1rem',
              gap: '1rem'}">
                <p :style="{margin: '0px'}"> {{ pausedNotificationsPeriod }}</p>
                <div class="div_button">
                    <v-btn
                    color="primary"
                    @click="gestNotifications({})"
                    >
                    <v-icon>mdi-trash-can-outline</v-icon>
                    {{ $t('stopMobileNotif.buttons.deleteNotifications') }}
                    </v-btn>
                </div>
              </v-row>
            </v-row>
          </v-col>
        </v-row>
  </div>
</template>

<script>
export default {
  props: {
  },
  data() {
    return {
      date_inicio: '',
      date_fin: '',
      menu_inicio: false,
      selectedPeriod: '',
      errorMessage: null,
      pausedNotificationsPeriod: '',
      show: false,
      selectedDates: [],
    };
  },
  methods: {
    sendDatesValues() {
      if (this.selectedDates.length === 2) {
        this.stopNotifications();
      }
    },
    closeMenu() {
      this.menu_inicio = false;
    },
    allowedDatesIni(value) {
      const date = new Date(value);
      const dateBeforeToday = !(date < new Date().setDate(new Date().getDate() - 1));
      return dateBeforeToday;
    },
    check30Days() {
      const inicio = new Date(this.date_inicio);
      const fin = new Date(this.date_fin);
      const seconds = 86400000;
      const days = Math.round((fin - inicio) / seconds);

      if (Number.isNaN(days)) {
        this.errorMessage = this.$t('stopMobileNotif.errors.requiredRange');
        return false;
      }

      if (days < 0) {
        this.errorMessage = this.$t('stopMobileNotif.errors.wrongDates');
        return false;
      }

      if (days > 30) {
        this.errorMessage = this.$t('stopMobileNotif.errors.maxDays');
        return false;
      }

      return true;
    },
    formatDate(date) {
      if (date === '') return '';
      const dateSplitted = date.split('T')[0].split('-');
      const formattedDate = `${dateSplitted[2]}/${dateSplitted[1]}/${dateSplitted[0]}`;
      return formattedDate;
    },
    formatDateToCGESFormat(date) {
      if (date === '') return '';
      const fecha = new Date(date);
      const mes = (fecha.getMonth() + 1) < 10 ? `0${fecha.getMonth() + 1}` : fecha.getMonth() + 1;
      const dia = (fecha.getDate()) < 10 ? `0${fecha.getDate()}` : fecha.getDate();
      const formattedDate = `${fecha.getFullYear()}-${mes}-${dia}`;
      return formattedDate;
    },
    async stopNotifications() {
      this.date_inicio = new Date(this.selectedDates[0]);
      this.date_fin = new Date(this.selectedDates[1]);
      if (this.date_inicio === '' && this.date_fin === '' && this.selectedPeriod === '') {
        this.errorMessage = this.$t('stopMobileNotif.errors.required');
      } else {
        this.errorMessage = null;

        let fechaInicio = '';
        let fechaFin = '';

        if (this.selectedDates.length === 2) {
          if (this.check30Days()) {
            fechaInicio = `${this.formatDateToCGESFormat(this.date_inicio)}T00:00:00.000Z`;
            fechaFin = `${this.formatDateToCGESFormat(this.date_fin)}T00:00:00.000Z`;
          }
        }
        if (this.selectedPeriod !== '') {
          const days = this.selectedPeriod.day;

          fechaInicio = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000))
            .toISOString().substr(0, 10);
          fechaFin = new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000);
          fechaFin = new Date(fechaFin.setDate(fechaFin.getDate() + days))
            .toISOString().substr(0, 10);
        }

        if (fechaInicio !== '' && fechaFin !== '') await this.gestNotifications({ fechaInicio, fechaFin });
      }
    },
    async gestNotifications({ fechaInicio = '', fechaFin = '', showMessage = true }) {
      let messageId;
      if (showMessage) {
        messageId = await this.$store.dispatch(
          'messages/createNotificationMessage',
          {
            icon: 'progress-circular',
            title: this.$t('stopMobileNotif.sending'),
          },
        );
      }

      try {
        const { id, userid } = this.$store.getters['session/user'];

        const data = {
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
            endpoint: `gestnotif/suscriptores/${userid}`,
          },
          fechaSilenciarIni: fechaInicio,
          fechaSilenciarFin: fechaFin,
        };
        const response = await this.gestorNotificacion.putStopNotifications(data);

        if (!showMessage) return;

        const sucessMessage = (fechaInicio !== '' && fechaFin !== '')
          ? this.$t('stopMobileNotif.successPause')
          : this.$t('stopMobileNotif.successDelete');

        if (response.status === 200) {
          await this.getNotifications();
          this.$store.dispatch('messages/updateMessage', {
            id: messageId,
            type: 'success',
            icon: 'mdi-check-circle',
            title: sucessMessage,
            timeout: this.$getConst('notifications.timeout'),
          });
        } else {
          this.$store.dispatch('messages/updateMessage', {
            id: messageId,
            type: 'error',
            icon: 'mdi-close-circle',
            title: this.$t('stopMobileNotif.error'),
            timeout: this.$getConst('notifications.timeout'),
          });
        }
      } catch (error) {
        this.$store.dispatch('messages/updateMessage', {
          id: messageId,
          type: 'error',
          icon: 'mdi-close-circle',
          title: this.$t('stopMobileNotif.error'),
          timeout: this.$getConst('notifications.timeout'),
        });
      }
    },
    async getNotifications() {
      try {
        const { id, userid } = this.$store.getters['session/user'];

        const data = {
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
            endpoint: `gestnotif/suscriptores/${userid}`,
          },
        };
        const response = await this.gestorNotificacion.getStopNotifications(data);

        if (response.status === 200) {
          const { fechaSilencioIni, fechaSilencioFin } = response.data.suscriptor[0].fechas;

          if (fechaSilencioIni !== null && fechaSilencioFin !== null) {
            /* if (new Date(fechaSilencioFin) < new Date('2024-11-30')) { // Prueba comprobar que se elimina para fechas inferiores a la actual */ // eslint-disable-line
            if (new Date(fechaSilencioFin) < new Date()) {
              await this.gestNotifications({ showMessage: false });
            } else {
              let dateSplitted = fechaSilencioIni.split('T')[0].split('-');
              const fomattedIni = `${dateSplitted[2]}/${dateSplitted[1]}/${dateSplitted[0]}`;

              dateSplitted = fechaSilencioFin.split('T')[0].split('-');
              const fomattedFin = `${dateSplitted[2]}/${dateSplitted[1]}/${dateSplitted[0]}`;

              this.pausedNotificationsPeriod = `${fomattedIni} - ${fomattedFin}`;
            }
          } else {
            this.pausedNotificationsPeriod = '';
          }
          this.selectedDates = [];
          this.show = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
    orderDates() {
      const dates = this.selectedDates;

      if (dates.length >= 2) {
        if (new Date(dates[1]) < new Date(dates[0])) {
          this.selectedDates.reverse();
        }

        if (new Date(this.selectedDates[1]) > new Date(this.maxDate)) {
          this.selectedDates.splice(1, 1, this.maxDate);
        }
      }
    },
  },
  computed: {
    computedDateFormatted() {
      if (this.selectedDates.length === 2) {
        this.closeMenu();
        return `${ this.formatDate(this.selectedDates[0]) } - ${ this.formatDate(this.selectedDates[1])}`;
      }
      return '';
    },
    maxDate() {
      if (this.selectedDates.length >= 1) {
        const initDate = new Date(this.selectedDates[0]);
        return new Date(initDate.setDate(initDate.getDate() + 29)).toISOString().slice(0, 10);
      }
      return '';
    },
  },
  async created() {
    this.gestorNotificacion = this.$api.getClient('gestorNotificacion');
    await this.getNotifications();
  },
};
</script>

<style lang="scss" scoped>

    .v-application--is-ltr .v-expansion-panel-header {
        width: fit-content !important;
        text-align: left !important;
    }

    .main_row{
        margin-right: 2rem;
        gap: 1rem;
    }

    .selectors_row {
        margin-left: 0.3rem;
        gap: 3rem;
    }
    .notif_title {
        margin: 0;
        text-align: end;
    }
    .notif_description{
        margin: 0 !important;
        width: auto ;
        text-align: start;
    }

    .v-expansion-panel::before {
        box-shadow: none !important;
    }

    .v-text-field__details{
      display: none !important;
    }
    .div_select {
        width: 13rem;
    }

    .div_datepickers{
        display: flex;
        flex-wrap: wrap;
        gap: 2rem;
        margin-left: 1rem !important;
        align-items: center !important;
    }
    .titleNotif{
            margin-left: 0.8rem !important;
        }

    .error_message {
        color: red;
        margin-bottom: 0;
    }

    #app {
      display: none;
    }

    .period-style {
      margin-left: 2rem;
    }

    @media screen and (max-width: 827px) {

      .period-style {
        margin-left: 0.5rem;
      }

      .mobile_style {
        padding-left: 0;
        width: 16rem;
      }
        #web {
          display: none;
        }

        #app {
          display: inline;
        }
        .main_row {
            margin-right: 0;
        }

        .selectors_row{
            margin: 0;
            display: flex !important;
            align-content: flex-start !important;
            gap: 1rem;
        }

        .notif_description {
            display:none !important;
            width: auto;
        }

        .div_datepickers {
          margin-left: 0 !important;
          display: block;
          flex-wrap: nowrap !important;
          gap: 1rem !important;
          align-items: center !important;
        }
        .titleNotif{
          text-align: start;
          margin-left: 1.2rem !important;
        }
       .datepicker {
          padding-left: 1rem !important;
        }
        .col_button{
            width: 100%;
        }
        .div_button{
            display: flex;
            justify-content: end;
        }
        .div_select {
          margin-bottom: -22px;
        }
    }

</style>
